export class DestinationSelectorOptionsLoadError extends Error {
  readonly cause: unknown

  constructor(cause: unknown) {
    super('Error loading destination selector options')
    this.name = 'DestinationSelectorOptionsLoadError'
    this.cause = cause
  }
}
